import Vue from 'vue';
import store from './../../store';
import accountService from "./index";

// When the request succeeds
const success = (data, context) => {

};

// When the request fails
const failed = (error, context) => {
  context.showToasterError(error);
};

export default (context, player) => Vue.$http.post('/set-one-signal-player-id', player).then((response) => {
  if (response && response.status === 200) {
    success(response.data, context);
  }
})
.catch((error) => {
  failed(error, context);
});



// WEBPACK FOOTER //
// ./src/app/services/account/setOneSignalPlayerId.js